import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const downloadUserReports = ({ payload = {}, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/reports/user-reports/download/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createUserReport = ({ payload, version = 'v1' }) =>
  client
    .request({
      url: `${version}/reports/user-reports/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const fetchReportDetails = ({ version = 'v1', reportType, params }) =>
  client
    .request({
      url: `${version}/reports/${reportType}`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
